import { render, staticRenderFns } from "./ranking-table.vue?vue&type=template&id=132ad13a&scoped=true&"
import script from "./ranking-table.vue?vue&type=script&lang=ts&"
export * from "./ranking-table.vue?vue&type=script&lang=ts&"
import style0 from "./ranking-table.vue?vue&type=style&index=0&id=132ad13a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132ad13a",
  null
  
)

export default component.exports